import React from 'react';
import { Paper } from '@mui/material';
import { UpdateTableFormHeader } from './UpdateTableFormHeader';

interface SidebarProps {
  children: React.ReactNode;
  onDone?: () => void;
  onClose: () => void;
  title: string;
  showDoneButton?: boolean;
}

export const Sidebar: React.FC<SidebarProps> = ({ children, onDone, onClose, title, showDoneButton = true }) => {
  return (
    <Paper className="absolute top-0 right-0 h-full w-[350px] flex flex-col justify-between">
      <UpdateTableFormHeader title={title} onClose={onClose} />
      <div className="relative pb-5 h-full" style={{ overflowY: 'auto' }}>
        {children}
      </div>
      {showDoneButton && onDone && (
        <div className="absolute bottom-0 p-6 border-t border-gray-300 bg-white w-full flex flex-row">
          <div className="flex-1">
            <button
              className="w-full py-5 bg-blue-700 border-none font-normal rounded-full m-1 text-white text-base cursor-pointer"
              onClick={onDone}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </Paper>
  );
};
